<template>
  <div class="index">
    <nav-header />
    <div class="content">
      <!--
     <div class="fixed">
      <div class="items" @click="phones()">
        <img src="../assets/img/phone (1).png" width="32px" height="auto" ></img>
        <div>Tel</div>
      </div>
      <div class="items" @click="goViewPages('contact')">
        <img src="../assets/img/ic_eamil.png" width="32px" height="auto" ></img>
        <div>Email</div>
      </div>
      <div class="items" @click="goViewPages('contact')">
        <img src="../assets/img/YDUI-编写.png" width="32px" height="auto" ></img>
        <div>Message</div>
      </div>
      <div class="items" @click="topsss()">
        <img src="../assets/img/top.png" width="32px" height="auto" ></img>
        <div>Top</div>
      </div>
     </div>-->
      <div class="swiper-centers">
        <swiper class="swiper-container" :options="swiperOption">
          <swiper-slide v-for="(item, index) in slideList" :key="index" :data-v="item.link" v-if="viewportWidth>440">
            <div class="slide-boxs" @click="goWebPages(item)">
              <div class="animate-box slide">
                <p class="animate text-h2" data-ani="slideInRight">{{ item.textcontent }}</p>
                <p class="animate text-p" data-ani="slideInRight" data-delay="1000">{{ item.textcontents }}</p>
                <p class="animate text-p" data-ani="slideInRight" data-delay="1000">{{ item.textcontentss }}</p>
                <div class="slide-mores animate" data-ani="slideInRight" data-delay="1000" :data-v="item.link">
                  <div class="slide-more " :data-v="item.link">View More</div>
                </div>
              </div>
            </div>
            <img :src="baseUrl + item.image" alt="" width="100%" height="auto" />
          </swiper-slide>

          <swiper-slide v-for="(item, index) in slideList" :key="index" :data-v="item.link" v-if="viewportWidth<=440">
            <div class="slide-boxs" @click="goWebPages(item)">
              <div class="animate-box slide">
                <p class="animate text-h2" data-ani="slideInRight">{{ item.textcontent }}</p>
                <p class="animate text-p" data-ani="slideInRight" data-delay="1000">{{ item.textcontents }}</p>
                <p class="animate text-p" data-ani="slideInRight" data-delay="1000">{{ item.textcontentss }}</p>
                <div class="slide-mores animate" data-ani="slideInRight" data-delay="1000" :data-v="item.link">
                  <div class="slide-more " :data-v="item.link">View More</div>
                </div>
              </div>
            </div>
            <img :src="baseUrl + item.mobileimage" alt="" width="100%" height="auto" />
          </swiper-slide>
        </swiper>
      </div>
      <div class="products-centers animate" data-ani="slideInRight" data-delay="500">
        <div class="products-nav-centers">
          <div class="products-titles">PRODUCT CENTER</div>
          <div class="products-contents">LATEST PRODUCTS</div>
          <div class="products-leixing">
            <el-select v-model="value" placeholder="ALL" @change="getProductList">
              <el-option v-for="item in soptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="swiper-s">
          <swiper class="swiper-container" :options="options">
            <swiper-slide v-for="(item, index) in product"
              :key="index"><!--@click="goViewPages('/detail/' + item.id)"-->
              <div class="items " @click="goViewPages('/detail/' + item.id)">
				        <div class="item-line"></div>
                <!--
                <div class="titles animate" data-ani="slideInRight" data-delay="500">{{ item.title }}</div>
                <div class="models animate" data-ani="slideInRight" data-delay="500">{{ item.model }}</div>-->
                <div class="direction"></div>
                <img :src="baseUrl + item.image" alt="" width="100%" height="auto" />
                <div class="title">{{ item.title }}</div>
                <div class="model">{{ item.model }}</div>
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </div>
        <div class="slide-mores animate" data-ani="slideInRight" data-delay="500" @click="goViewPages('product/1')">
          <div class="slide-more ">View More</div>
        </div>
      </div>
      <div class="web_content">
        <div class="about-items animate-box">
          <div class="left animate" data-ani="bounceInLeft">
            <div class="about-title">ABOUT US</div>
            <div class="fonts">ZHEJIANG YINGCHENG</div>
            <div class="fonts">INTERNATIONAL TRADE</div>
            <div class="fonts">CO., LTD.</div>
            <div class="text">
              <div>We have more than 20 years of production and sales experience, focusing on
                the manufacture of professional quality tools and hardware products,
                including pumps, cleaning machines, power tools, hand tools and more. From
                product design, Production, Packaging to inspection, every step is strictly
                checked, Besides, Our products have passed the main international...
              </div>
            </div>
            <div class="slide-mores" @click="goViewPages('about/1')">
              <div class="slide-more ">View More</div>
            </div>
          </div>
          <div class="right animate" data-ani="bounceInRight">
            <video-player class="video-player-box" ref="videoPlayer" :playsinline="true" :options="playerOptions">
            </video-player>
          </div>
          <div class="lefts animate" data-ani="bounceInLeft">
            <div class="about-title">ABOUT US</div>
            <div class="fonts">ZHEJIANG YINGCHENG</div>
            <div class="fonts">INTERNATIONAL TRADE</div>
            <div class="fonts">CO., LTD.</div>
            <div class="text">
              <div>We have more than 20 years of production and sales experience, focusing on
                the manufacture of professional quality tools and hardware products,
                including pumps, cleaning machines, power tools, hand tools and more. From
                product design, Production, Packaging to inspection, every step is strictly
                checked, Besides, Our products have passed the main international...
              </div>
            </div>
            <div class="slide-mores" @click="goViewPages('about/1')">
              <div class="slide-more ">View More</div>
            </div>
          </div>
        </div>

        <div class="animate-box mobile-product-s">
          <div class="left animate" data-ani="bounceInLeft">
            <div class="items_1" style="width: 100%;overflow: hidden;position: relative;" @click="goViewPages('product/22')">
              <div class="box-green"></div>
              <div class="product-p"></div>
              <div class="p-1"></div>
              <div class="direction-p"></div>
              <div class="text-p">Water Pump</div>
              <img src="../assets/img/syfl-1.jpg" alt="" width="120%" height="auto" />
            </div>
          </div>
          <div class="right animate" data-ani="bounceInRight">
            <div class="right-s">
              <div style="width: 100%;overflow: hidden;position: relative;" class="items_2"  @click="goViewPages('product/38')">
                <div class="box-green"></div>
                <div class="product-p"></div>
                <div class="p-2"></div>
                <div class="direction-p"></div>
                <div class="text-ps">High Pressure Washer</div>
                <img src="../assets/img/syfl-2.jpg" alt="" width="100%" height="auto" />
              </div>
              <div style="width: 100%;overflow: hidden;position: relative;margin-top: -4px;" class="items_2"  @click="goViewPages('product/37')">
                <div class="box-green"></div>
                <div class="product-p"></div>
                <div class="p-3"></div>
                <div class="direction-p"></div>
                <div class="text-ps" style="width: 128px;line-height: 18px;"> Generator</div>
                <img src="../assets/img/syfl-3.jpg" alt="" width="100%" height="auto" />
              </div>
            </div>
          </div>
        </div>
        <div class="animate-box mobile-product-s" style="padding:0px 0px 0px 0px;margin-top: -3px;">
          <div class="left animate" data-ani="bounceInLeft" style="width: 50%;">
            <div class="items_1" style="width: 100%;overflow: hidden;position: relative;"  @click="goViewPages('product/19')">
              <div class="box-green"></div>
              <div class="product-p"></div>
              <div class="p-4"></div>
              <div class="direction-p"></div>
              <div class="text-p">Equipment</div>
              <img src="../assets/img/syfl-4.jpg" alt="" width="100%" height="auto" />
            </div>
          </div>
          <div class="right animate" data-ani="bounceInRight" style="width: 50%;">
            <div class="right-s">
              <div class="items_1" style="width: 100%;overflow: hidden;position: relative;"  @click="goViewPages('product/25')">
                <div class="box-green"></div>
                <div class="product-p"></div>
                <div class="p-5"></div>
                <div class="direction-p"></div>
                <div class="text-ps" >Cordless Tools</div>
                <img src="../assets/img/syfl-5.jpg" alt="" width="100%" height="auto" />
              </div>
            </div>
          </div>
        </div>
        <div class="animate-box product-s">
          <div class="left animate" data-ani="bounceInLeft">
            <div class="items_1" style="width: 100%;overflow: hidden;position: relative;"  @click="goViewPages('product/22')">
              <div class="box-green"></div>

              <div class="product-p"></div>
              <div class="p-1"></div>
              <div class="direction-p"></div>
              <div class="text-p">Water Pump</div>

              <img src="../assets/img/syfl-1.jpg" alt="" width="100%" height="auto" />
            </div>
          </div>
          <div class="right animate" data-ani="bounceInRight">
            <div class="right-s">
              <div style="width: 50%;overflow: hidden;position: relative;" class="items_2"  @click="goViewPages('product/38')">
                <div class="box-green"></div>

                <div class="product-p"></div>
                <div class="p-2"></div>
                <div class="direction-p"></div>
                <div class="text-ps">High Pressure Washer</div>

                <img src="../assets/img/syfl-2.jpg" alt="" width="100%" height="auto" />
              </div>
              <div style="width: 50%;overflow: hidden;position: relative;" class="items_2"  @click="goViewPages('product/37')">
                <div class="box-green"></div>

                <div class="product-p"></div>
                <div class="p-3"></div>
                <div class="direction-p"></div>
                <div class="text-pss">Generator</div>

                <img src="../assets/img/syfl-3.jpg" alt="" width="100%" height="auto" />
              </div>
            </div>
            <div class="right-s" style="margin-top: -4px;">
              <div style="width: 50%;overflow: hidden;position: relative;" class="items_2"  @click="goViewPages('product/19')">
                <div class="box-green"></div>

                <div class="product-p"></div>
                <div class="p-4"></div>
                <div class="direction-p"></div>
                <div class="text-psss">Equipment</div>

                <img src="../assets/img/syfl-4.jpg" alt="" width="100%" height="auto" />
              </div>
              <div style="width: 50%;overflow: hidden;position: relative;" class="items_2"  @click="goViewPages('product/25')">
                <div class="box-green"></div>
                <div class="product-p"></div>
                <div class="p-5"></div>
                <div class="direction-p"></div>
                <div class="text-pssss">Cordless Tools</div>
                <img src="../assets/img/syfl-5.jpg" alt="" width="100%" height="auto" />
              </div>
            </div>
          </div>
        </div>
        <div class="index-call-s" @mouseover="start" @touchstart="start">
          <div class="mobile-p-s">
            <div class="index-content">
              <div class="title">OUR SERVICE</div>
              <div class="text-1">STRICTLY CHECK</div>
              <div class="text-1">EVERY STEP</div>
              <div class="text-2">
                Besides, Our products have passed the main international safety certification and strictly comply with
                the ISO9002 quality control system certification.At the same time,we have established a good
                relationship of mutual trust with customers all over the world, and also for customers to succeed in
                the local market.
              </div>
              <div class="slide-mores" @click="goViewPages('about/0')" ><!--@click="goViewPages('about/1')"-->
                <div class="slide-more">View More</div>
              </div>
              <div class="phone_centers"@click="phones()" ><!--@click="phones()"-->
                <div class="p-n">
                  <div>+86-135-8600-1336</div>
                  <div style="font-size: 15px;font-weight: 400;">Call me now !</div>
                </div>
                <div class="call-tos">
                  <div class="call-to"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="call-1-s">
            <div class="left">
              <div class="centers-c">
                <div class="ceneters-s">
                  <div class="centers-1">
                    <div class="text-1s">
                      
                      <countTo ref='example1' :startVal="startVal" :endVal="endVal" :duration="2000"></countTo>+
                    </div>
                    <div class="text-1">
                      More than 300 models
                    </div>
                  </div>
                  <div class="centers-2">
                    <div class="text-1s">
                      
                      <countTo ref='example2' :startVal="startVals" :endVal="endVals" :duration="2000"></countTo>+
                    </div>
                    <div class="text-1">
                      Sold in multiple countries
                    </div>
                  </div>
                </div>
              </div>
              <img src="../assets/img/syfw-1.jpg" alt="" width="100%" height="auto">
            </div>
          </div>
          <div class="p-s">
            <div class="index-content">
              <div class="title">OUR SERVICE</div>
              <div class="text-1">STRICTLY CHECK</div>
              <div class="text-1">EVERY STEP</div>
              <div class="text-2">
                Besides, Our products have passed the main international safety certification and strictly comply with
                the ISO9002 quality control system certification.At the same time,we have established a good
                relationship of mutual trust with customers all over the world, and also for customers to succeed in
                the local market.
              </div>
              <div class="slide-mores" @click="goViewPages('about/0')" ><!--@click="goViewPages('about/1')"-->
                <div class="slide-more ">View More</div>
              </div>
              <div class="phone_centers" @click="phones()"><!--@click="phones()"-->
                <div class="p-n">
                  <div class="text1">+86-135-8600-1336</div>
                  <div class="text2">Call me now !</div>
                </div>
                <div class="call-tos">
                  <div class="call-to"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mobile-p-t">
          <div class="p-o">
            <div class="p-s">
              <div class="p-titles">PRODUCTION CENTER</div>
              <div class="p-text " style="margin-top: 15px;">CUSTOMER SATISFACTION</div>
              <div class="p-text ">IS OVER 97%</div>
              <div class="slide-mores" @click="goViewPages('product/1')">
                <div class="slide-more ">View More</div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-t">
          <img src="../assets/img/f-1.png" width="100%" height="auto"></img>
          <div class="p-o">
            <div class="p-s">
              <div class="p-titles">PRODUCTION CENTER</div>
              <div class="p-text " style="margin-top: 25px;">CUSTOMER SATISFACTION</div>
              <div class="p-text ">IS OVER 97%</div>
              <div class="slide-mores" @click="goViewPages('product/1')">
                <div class="slide-more ">View More</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <nav-footer />
  </div>
</template>
<script>
import countTo from 'vue-count-to';

import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import NavHeader from "@/components/NavHeaders.vue";
import NavFooter from "@/components/NavFooter.vue";
import "swiper/css/swiper.css";
import ApiCon from "../util/Api/index";
import { __esModule } from "vue2-editor";
export default {
  name: "index",
  data() {
    return {
      startVal: 0,
      endVal: 300,
      startVals: 0,
      viewportWidth:'',
      endVals: 150,
      page: 1,
      current_page: 0,
      playerOptions: {
        controls: true,
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "video/mp4", // 类型
          src: 'http://yingcheng.0576hs.com/uploads/media.mp4' // url地址
        }],
        poster: 'http://yingcheng.0576hs.com/uploads/cs_3.png', // 封面地址
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: true, // 是否显示剩余时间功能
          fullscreenToggle: true // 是否显示全屏按钮
        }
      },
      soptions: [{
        value: '',
        label: 'ALL'
      },
   
      {
        value: '31',
        label: 'WATER PUMP'
      },
      {
        value: '32',
        label: 'HGIH PRESSURE WASHER'
      },
      {
        value: '30',
        label: 'GENERATOR'
      },
      {
        value: '37',
        label: 'CORDLESS TOOLS'
      },
      {
        value: '28',
        label: 'EQUIPMENT'
      },
      ],
      soptionss: [{
        value: '选项1',
        label: 'ALL'
      }, {
        value: '选项2',
        label: 'POWER TOOLS'
      },
      ],
      values: '',
      baseUrl: 'http://yingcheng.0576hs.com',
      product: [

      ],
      value: '',
      options: {  // 设置slides可视数量
        slidesPerView: 3,
        // 设置滑块之间的距离
        spaceBetween: 15,
        // 其他你可能需要的配置
        loop: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      swiperOption: {
        autoplay: true,
        loop: true,
        speed: 4000,
        cubeEffect: {
          shadowOffset: 100,
          shadowScale: 0.6,
        },
      },
      slideList: [

      ],
      newsList: [],
      firstNews: '',
      left_options: {
        notNextTick: true,
        direction: 'vertical',
        setWrapperSize: true,
        freeMode: true,//true则是自由模式，不会自动贴合滑动位置
        loop: true,//循环
        loopedSlides: 3,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        loopAdditionalSlides: 1,
        spaceBetween: 0,//slide之间的距离，px
        slidesPerView: 3,//slide可见数量
        mousewheelControl: true,//鼠标滚轮控制
        grabCursor: true,//鼠标变为抓手
        // observer: true,
      },
      cpnum: '',
      cpthumbnum: '',
      cpthumbshow: false,
    };
  },
  components: {
    Swiper,
    countTo,
    SwiperSlide,
    NavHeader,
    NavFooter,
  },
  mounted() {
    this.ApiCon = new ApiCon(this.$store);
    this.ApiConUrl = this.ApiCon.getApiUrl();

    //this.getnewsList();
    localStorage.clear();
    this.$nextTick(() => {
      this.handleAnimate()//初始化第一次加载时在视口内就执行动画
      addEventListener('scroll', this.handleAnimate);
    })

  },
  created() {
    this.ApiCon = new ApiCon(this.$store)
    let viewportWidth = document.documentElement.clientWidth
    document.body.scrollTop = "0px"
    //this.$layer.msg('你好')
    this.ApiConUrl = this.ApiCon.getApiUrl()
    this.baseUrl = this.ApiConUrl
    let self = this
    self.viewportWidth=viewportWidth
    if (viewportWidth < 440) {
      self.options = {  // 设置slides可视数量
        slidesPerView: 1,
        // 设置滑块之间的距离
        spaceBetween: 15,
        // 其他你可能需要的配置
        loop: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      }
    }
    self.getProductList()
    self.getBannerLists()
    setTimeout(this.handleAnimate, 1000)
  },
  destroyed() {
    removeEventListener('scroll', this.handleAnimate);
  },
  methods: {
    phones() {
      window.location.href = `tel://+8613586001336`;
      //`tel://${phone}`
      // window.location.href = 'tel:+8613586001336';
    },
    topsss(){
      document.documentElement.scrollTop = "0px";
    },
    goWebPages(val) {
      if(val.link!=''){
        window.open(val.link)
      }
    },
    goViewShow(val) {
      console.log(val)
    },
    goViewPages(val) {
      // console.log('sssbb')
      let self = this
      self.$router.push(val);
    },
    /**
    next(){
      let self=this
      if(self.page<=0){
          self.$layer.msg('Please right')
          return
      }
      self.page--
      self.getProductList()
    },
    prev(){
      let self=this
      if(self.page>self.current_page){
          self.$layer.msg('Please left')
          return
      }
      self.page++
      self.getProductList()
    },
    **/
    getProductList() {
      this.$api.mall.getProductList({ type: this.value, page: 1, limit: 12 }).then((res) => {
       // let item = res.data.data.data[0]
        //for (var i = 0; i < 3; i++) {
          this.product=res.data.data.data
        //}
        this.current_page = res.data.data.current_page
        this.total = res.data.data.total
      });
    },
    start() {
      this.$refs.example1.start();
      this.$refs.example2.start();
    },
    handleAnimate() {
      let top = pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      let vh = document.documentElement.clientHeight;
      let dom = document.querySelectorAll(".animate");
      [].slice.call(dom).forEach(v => {
        if (top + vh > v.offsetTop) {
          var delay = v.dataset.delay;
          if (delay) {
            setTimeout(() => {
              v.style.opacity = 1;
              v.classList.add(v.dataset.ani)
            }, delay)
          } else {
            v.style.opacity = 1;
            v.classList.add(v.dataset.ani)
          }
        } else {
          v.classList.remove(v.dataset.ani)
          v.style.opacity = 0;
        }
      })
    },
    goProPage(val) {
      let self = this;
      self.$router.push("/product_type_list/" + val);
      localStorage.clear();
    },
    goPages(val) {
      this.$router.push(val);
    },
    getBannerLists() {
      let self = this;
      this.$api.mall
        .getBannerList({
          limit: 14,
          page: 1,
        })
        .then((ress) => {
          let res = ress.data.data.data;
          self.slideList = res;
        });
    },
    getnewsList() {
      let self = this;
      this.$api.mall
        .getNews({
          limit: 10,
          page: 1,
          type: '',
        })
        .then((ress) => {
          let res = ress.data.data.data;
          self.newsList = res;
          self.firstNews = res[0]
        });
    },
    handleave(val) {
      let self = this;
      if (self.activea == 1) {
        self.cpthumbnum = "";
        self.nava = "";
        self.showsNav = false;
      } else {
        self.cpthumbnum = ''
        self.nava = self.activenava;
      }
      self.cpnum = self.activea;
    },
    cphover(val) {
      let self = this;
      console.log(val)
      self.cpnum = val;
      self.cpthumbnum = val;
      self.cpthumbshow = true;
    },

  },
};
</script>
<style lang='scss' scoped>
@import "src/assets/scss/newindex";
</style>
